<template>
    <section class="map-block">
        <div class="map">
            <div class="map-inner" ref="map">
            </div>

        </div>
    </section>
</template>

<script>
import {Loader} from 'google-maps';
import {style} from '@/utils/MapStyles';
import Marker from "@/utils/HTMLMapMarker";

export default {
    name: 'map-block',

    props: {
      data: Object,
    },

    data() {
      return {
        loader: null,
      }
    },

    methods: {
        map() {
            let el = this.$refs.map;
            let lat = this.data.map.lat;
            let lng = this.data.map.lng;
            let zoom = this.data.map.zoom;
            let LatLng = {lat: lat,lng: lng};


            let gmap = new google.maps.Map(el, {
                styles: style,
                mapTypeControl: false,
                zoomControl: true,
                scaleControl: false,
                streetViewControl: false,
                fullscreenControl: false,
                center: LatLng,
                zoom: zoom
            });

            let marker = Marker({
                latlng:  new google.maps.LatLng(lat, lng),
                map: gmap,
                html: `<svg viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"></path></svg><div class="text">${this.data.content}</div>`,
                className: 'marker-wrap',
                id: 'js-marker-current'
            });

        },
    },

    // components: {
    //     Content,
    // },
    mounted() {
        let self = this;

        if (typeof google === 'undefined') {
            this.loader = new Loader(window.globals.map_key, {
                version: 'quarterly',
            });

            this.loader.load().then(function (google) {
                self.map();
            });
        } else {
            self.map();
        }

        // console.log(this.data)


    },
}
</script>

<style lang="scss">
    .map-block {
        padding: var(--padding) 8rem;
        width: var(--inner-size);
        margin: auto;


        .map {
            background: white;
            position: relative;

            &::before {
                content: '';
                display: block;
                padding-bottom: 55%;
            }

            &:hover .marker-wrap .text {
                opacity: 1;
                transform: translate(-50%, -100%);
                opacity: 0;
            }
        }

        .map-inner {
            color: black;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
        }

        .marker-wrap {
            font-size: var(--navi-size);
            background: var(--theme-color-3);
            color: #fff;
            text-align: center;
            transform: translate(-25%, -25%);
            height: 3.2rem;
            width: 3.2rem;
            border-radius: 50%;
            position: relative;

            svg {
                height: 100%;
                width: 100%;
                fill: var(--theme-1-color-2);
            }

            .text {
                position: absolute;
                top: -.5rem;
                left: 50%;
                transform: translate(-50%, -90%);
                background: white;
                color: black;
                padding: 1rem;
                box-shadow: 0 1px 3px 1px rgba(#000, .3);
                border-radius: .25rem;
                min-width: 20rem;
                opacity: 0;
                transition: all .2s ease-in-out;
                font-size: var(--small-size);

                // &::after {
                //     top: 95%;
                //     left: 50%;
                //     border: solid transparent;
                //     content: "";
                //     height: 0;
                //     width: 0;
                //     position: absolute;
                //     pointer-events: none;
                //     border-color: rgba(255, 255, 255, 0);
                //     border-top-color: #fff;
                //     border-width: .5rem;
                //     margin-left: -.5rem;
                // }
            }


        }

    }

    @media only screen and (max-width: 767px) {
        .map-block {
            padding: 0 0 var(--padding);
        }
    }


</style>
